import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.cuid.com.br/',
  // baseURL: 'http://192.168.0.10:3333/',
 //baseURL: 'http://localhost:3333/',
});

export default api;
